var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-out-window"},[_vm._t("body",function(){return [_c('div',{staticClass:"loading-spinner"},[_c('loading',{attrs:{"color":"#00b2ce","size":"24px"}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }